import 'react-responsive-carousel/lib/styles/carousel.min.css';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';
import Image from 'next/image';
import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import { IResourceData } from 'utils/globalTypes';
import { defaultLoader } from 'utils/images';
import { getValidUrl } from 'utils/urlUtils';

import s from './SignUpFormPartners.module.scss';

const SignUpFormPartners = ({ partners }: { partners?: IResourceData[] }) => {
  if (!partners) {
    return null;
  }

  const validPartners = partners?.filter((partner) => partner?.url);
  if (isEmpty(validPartners)) {
    return null;
  }

  console.log('SignUp', validPartners);

  return (
    <div className={s.SignUpFormPartners}>
      <div className={s.SignUpFormPartners__title}>Our Partners</div>

      <Carousel
        centerMode
        centerSlidePercentage={55}
        showStatus={false}
        showIndicators={false}
        renderArrowNext={(onClick, hasNext) =>
          hasNext ? (
            <button
              type="button"
              onClick={onClick}
              className={cn(s.SignUpFormPartners__button, s.SignUpFormPartners__next)}
            >
              <ChevronRightIcon />
            </button>
          ) : null
        }
        renderArrowPrev={(onClick, hasPrev) =>
          hasPrev ? (
            <button
              type="button"
              onClick={onClick}
              className={cn(s.SignUpFormPartners__button, s.SignUpFormPartners__prev)}
            >
              <ChevronLeftIcon />
            </button>
          ) : null
        }
        showThumbs={false}
      >
        {validPartners.map((partner, i) => {
          return (
            <div key={`partner=${i}`} className={s.SignUpFormPartners__imgHolder}>
              <Image
                loader={defaultLoader}
                style={{ objectFit: 'contain' }}
                width={150}
                height={30}
                quality={70}
                priority
                src={getValidUrl(partner?.url) || ''}
                alt={partner?.description ?? ''}
              />
            </div>
          );
        })}
      </Carousel>
    </div>
  );
};

export default SignUpFormPartners;
